// extracted by mini-css-extract-plugin
module.exports = {"presetSum":"styles_presetSum__12H5w","activePreset":"styles_activePreset__2WmaU","cardInfo":"styles_cardInfo__3ggFW","spin":"styles_spin__3qufE"};